export default "__VITE_ASSET__Ch2sh9Z8__"